import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { CardSetIndividualResponseFailureReason } from '../../card-set-request/index.tsx';
import type { RetryableActionBuilder } from '../../meta/card-set-meta.tsx';

export const BULK_OPS_SHOW_FAILED_FLAG =
	'state.actions.bulk-ops-flags.BULK_OPS_SHOW_FAILED_FLAG' as const;

export type BulkOpsFailureReason = CardSetIndividualResponseFailureReason | 'mixed';

export type BulkOpsShowFailedFlagActionPayload = {
	failedIssueKeys: IssueKey[];
	failedActionBuilders: RetryableActionBuilder[];
	totalCount: number;
	failureReason: BulkOpsFailureReason;
	failedBatchIds?: string[];
};

export type BulkOpsShowFailedFlagAction = {
	type: typeof BULK_OPS_SHOW_FAILED_FLAG;
	payload: BulkOpsShowFailedFlagActionPayload;
};

export const bulkOpsShowFailedFlag = (
	payload: BulkOpsShowFailedFlagActionPayload,
): BulkOpsShowFailedFlagAction => ({
	type: BULK_OPS_SHOW_FAILED_FLAG,
	payload,
});
